<template>
    <project-template>

        <project-text
        size="25"
        :color="$store.state.activeProject.color">
          <h1>Iteration is Key</h1>
          <p>I began the process of creating DanAraujo.com by strategizing about what I wanted visitors to focus on when they came to my portfolio page. I decided I wanted my work to take center stage, and started designing around that concept. Once I had a good base of all the website’s pages designed, I started coding. However, as I continued to build the site I found myself going back to Figma to visualize new ideas and improve upon the site’s visual hierarchy, color schemes, typography, and layout.</p>
        </project-text>

        <project-video
        size="75"
        videoID="350652601"
        :gif="true"/>

        <project-text
        size="25"
        :color="$store.state.activeProject.color">
          <h1>How It's Made</h1>
          <p>This site is coded entirely in <a href="https://vuejs.org/" target="_blank">Vue</a> with an automated build process using Node.js and webpack. This is my first major project coded in Vue, and as such I learned a lot about the framework as I went along. DanAraujo.com uses single sources of data, like a JSON file containing project information which is used in various ways throughout the site, like on the homepage, the work page, and the robust project template system.<br><br>Github Repo is available upon request via <a href="mailto:dancaraujo@gmail.com?subject=Github Repo">email</a>.</p>
        </project-text>

        <project-image
        size="75"
        path="/img/p/portfolio/code.jpg"
        alt="DanAraujo.com Code"/>

        <project-text
        size="25"
        :color="$store.state.activeProject.color">
          <h1>Credit Where It's Due</h1>
          <p>I utilized several NPM packages for features that would be too cumbersome or time-consuming to build myself. For instance, I used <a href="https://www.npmjs.com/package/animejs" target="_blank">anime.js</a> for complex animations, <a href="https://www.npmjs.com/package/pts" target="_blank">pts.js</a> for the bouncing balls, <a href="https://www.npmjs.com/package/vue-burger-menu" target="_blank">vue-burger-menu</a> for the framework of the slide-out menu, and <a href="https://www.npmjs.com/package/vue-carousel" target="_blank">vue-carousel</a> for the image carousels on project pages. I did quite a bit of tinkering with these libraries to achieve the custom behaviors I needed for this site, and I was pleased to reach a harmony of everything playing nicely together.<br><br>This site liberally uses the <a href="https://mutant.tech/" target="_blank">Mutant Standard</a> emoji set, and of course a custom commissioned emoji of myself by its owner. The site also makes generous use of patterns from <a href="https://www.heropatterns.com/" target="_blank">HeroPatterns</a>.</p>
        </project-text>

        <project-image
        size="75"
        path="/img/p/portfolio/render.jpg"
        alt="DanAraujo.com Render with Code"/>

    </project-template>
</template>

<script>
import ProjectTemplate from '../../components/project/ProjectTemplate.vue'
import ProjectImage from '../../components/project/ProjectImage.vue'
import ProjectText from '../../components/project/ProjectText.vue'
import ProjectVideo from '../../components/project/ProjectVideo.vue'

export default {
  components: { ProjectTemplate, ProjectText, ProjectImage, ProjectVideo }
}
</script>

<style lang="scss" scoped>

</style>
